import { render } from "./SubjectVersions.vue?vue&type=template&id=7cd6f0c0"
import script from "./SubjectVersions.vue?vue&type=script&lang=js"
export * from "./SubjectVersions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__